import React, { useEffect, useState } from "react";
import "./QAOrganizationContent.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import QAOrganizationData from "../Data/QAOrganizationData.json";
import { elementAcceptingRef } from "@mui/utils";
import axios from "axios";
import techCategory from "../Data/techCategory.json";
import Alert from "@mui/material/Alert";
import mailData from "../Data/mailData.js";

function QAOrganizationContent() {
  const [trackAccess, setTtrackAccess] = useState();
  const [bool, setBool] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  const employee = {
    id: 1,
    name: "Bobby Hadz",
    // salary: 123,
  };

  function getTracks() {
    // axios.get("http://localhost:3021/track/getUsernames")
    axios
      .get("https://atci.lkm.qa.accenture.com/qa-apis/track/getUsernames")
      .then((res) => {
        setTtrackAccess(res.data);
        console.log(res.data, "resdataaaaa");
      })
      .catch((err) => {
        setFetchError(true);
        console.log(err);
      });
  }

  useEffect(() => {
    getTracks();
  }, []);

  var techWiseAccess = trackAccess?.["technology-wise-full-access"];
  // techWiseAccess.push(trackAccess?.["technology-wise-full-access"]);

  return (
    <>
      {/* {setTimeout(() => {
                setBool(true);
            }, 3000)} */}
      {console.log(trackAccess, "track access")}
      <div className="main-banner">
        <img
          src={process.env.PUBLIC_URL + "/images/QALKM/LKMQA-Banner.png"}
          alt="Banner"
          className="banner-img"
        />
        <div className="banner-content">
          <h1>QA Organization</h1>
          {/* <p><i>Lorem ipsum is simply dummy text of the printing</i></p> */}
        </div>
      </div>

      {/* section 1  */}
      {/* <div className="team-container">
                    <div className="team-wrap">
                        <h2>Internal Audit Team</h2>
                        <div className="team-row">
                            <div className="team-box">
                            <div className='QA_Org_cards'>
                                    <div className='QA_Org_image_sec'>
                                        <img src={process.env.PUBLIC_URL + "/images/QAOrganization/Gajendra Mallik.png"} alt="QA_org_img" className='QA_org_img' />
                                        <div className='QA_Org_content_sec'>
                                            <h3>Gajendra Mallik</h3>
                                            <p>Technology Delivery SME Assoc Director - QA Lead</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

      {/* Section 2 */}
      <div className="QA_Org_Main">
        <div className="internalTeam">
          <div className="QA_Org_heading">
            <h2>Internal Audit Team</h2>
            {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> */}
          </div>
          <div className="QA_Org_cards">
            <div className="QA_Org_image_sec">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/QAOrganization/Mukhvinder.png"
                }
                alt="QA_org_img"
                className="QA_org_img"
              />
              <div className="QA_Org_content_sec">
                <h3>Mukhvinder Bains</h3>
              </div>
            </div>
            <div className="QA_Org_image_sec">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/QAOrganization/Srinivas.png"
                }
                alt="QA_org_img"
                className="QA_org_img"
              />
              <div className="QA_Org_content_sec">
                <h3>Srinivas Nanjappa</h3>
              </div>
            </div>
            <div className="QA_Org_image_sec">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/QAOrganization/Sridhar.png"
                }
                alt="QA_org_img"
                className="QA_org_img"
              />
              <div className="QA_Org_content_sec">
                <h3>Sridhar Aluri</h3>
              </div>
            </div>
            <div className="QA_Org_image_sec">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/QAOrganization/Sangeetha.png"
                }
                alt="QA_org_img"
                className="QA_org_img"
              />
              <div className="QA_Org_content_sec">
                <h3>Sangeetha Ravi</h3>
              </div>
            </div>
            {/* <div className='QA_Org_image_sec'>
                            <img src={process.env.PUBLIC_URL + "/images/QAOrganization/Mukhvinder.png"} alt="QA_org_img" className='QA_org_img' />
                            <div className='QA_Org_content_sec'>
                                <h3>Mukhvinder Bains</h3>
                            </div>
                        </div> */}
          </div>
        </div>
        <div className="QA_Org_heading">
          <h2>QA Organization Structure</h2>
          {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> */}
        </div>
        <div className="QA_Org_cards">
          <div className="QA_Org_image_sec">
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/QAOrganization/Mukhvinder.png"
              }
              alt="QA_org_img"
              className="QA_org_img"
            />
            <div className="QA_Org_content_sec">
              <h3>Mukhvinder Bains</h3>
              <p>Ecosystem Supplier Mgmt Assoc Director, QA Lead</p>
            </div>
            <div className="QA_Org_icon_sec">
              <a
                href="https://wd103.myworkday.com/accenture/d/inst/1$247/247$816875.htmld?workerId=f523ff523398100c78bef34b96240000&priorityID=bf55403a05931000c26cf2c0b9760000#TABTASKID=2998%2440311"
                target="blank"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/contact_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img1"
                />
              </a>
              <a href="mailto:mukhvinder.bains">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/mail_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img2"
                />
              </a>
              <a href="javascript:void(0)">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/linked_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img3"
                />
              </a>
            </div>
          </div>
          <div className="QA_Org_image_sec">
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/QAOrganization/Srinivas.png"
              }
              alt="QA_org_img"
              className="QA_org_img"
            />
            <div className="QA_Org_content_sec">
              <h3>Srinivas Nanjappa</h3>
              <p>Project Control Services Manager</p>
            </div>
            <div className="QA_Org_icon_sec">
              <a
                href="https://wd103.myworkday.com/accenture/d/inst/autocompletesearch/247$1105520.htmld#TABTASKID=2998%2440311"
                target="blank"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/contact_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img1"
                />
              </a>
              <a href="mailto:srinivas.nanjappa">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/mail_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img2"
                />
              </a>
              <a href="javascript:void(0)">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/linked_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img3"
                />
              </a>
            </div>
          </div>
          <div className="QA_Org_image_sec">
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/QAOrganization/Sridhar.png"
              }
              alt="QA_org_img"
              className="QA_org_img"
            />
            <div className="QA_Org_content_sec">
              <h3>Sridhar Aluri </h3>
              <p>Tech Del and Ops Excellence Assoc Manager</p>
            </div>
            <div className="QA_Org_icon_sec">
              <a
                href="https://wd103.myworkday.com/accenture/d/inst/1$247/247$1244331.htmld?workerId=f523ff523398100c78bef34b96240000&priorityID=bf55403a05931000c26cf2c0b9760000#TABTASKID=2998%2440311"
                target="blank"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/contact_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img1"
                />
              </a>
              <a href="mailto:sridhar.aluri">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/mail_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img2"
                />
              </a>
              <a href="javascript:void(0)">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/linked_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img3"
                />
              </a>
            </div>
          </div>
          <div className="QA_Org_image_sec">
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/QAOrganization/Sangeetha.png"
              }
              alt="QA_org_img"
              className="QA_org_img"
            />
            <div className="QA_Org_content_sec">
              <h3>Sangeetha Ravi</h3>
              <p>Project Control Services Assoc Manager</p>
            </div>
            <div className="QA_Org_icon_sec">
              <a
                href="https://wd103.myworkday.com/accenture/d/inst/1$247/247$1823510.htmld?workerId=f523ff523398100c78bef34b96240000&priorityID=bf55403a05931000c26cf2c0b9760000#TABTASKID=2998%2440311"
                target="blank"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/contact_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img1"
                />
              </a>
              <a href="mailto:sangeetha.d.ravi">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/mail_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img2"
                />
              </a>
              <a href="javascript:void(0)">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/QAOrganization/linked_icon.png"
                  }
                  alt="QA_org_img"
                  className="QA_org_img3"
                />
              </a>
            </div>
          </div>

          <br />
        </div>

        <div className="QA_Org_champions">
          <h2>QA Champions</h2>
          <p className="QA_Champions_Para">
            QA Champions are the torchbearers of Quality Assurance activities
            representing their respective Tracks. They support the QA Team by
            acting as single point of contact for Tracks to implement the QA
            initiatives. They also need to ensure their respective track meets
            the Audit requirements.
          </p>
          {fetchError && (
            <Alert severity="error" className="errorAlert">
              <b>Internal Server Error:</b> Please try again with a hard
              refresh. If the issue persists, contact the LIS team for further
              assistance.
            </Alert>
          )}
          <div className="QA_accordion">
            {techCategory.map((item) => {
              console.log(item);
              return (
                <>
                  <Accordion>
                    <AccordionSummary
                      className="QAChampionsAccordianTitle"
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <div className="headingSplit">
                        <Typography className="accordian-header track-name">
                          <span>Track Name</span>
                          {item.trackName}
                        </Typography>
                        <Typography className="accordian-header track-lead">
                          <span>Track Lead</span>
                          {(Array.isArray(item.trackLead) ? item.trackLead : [item.trackLead])
                            .filter(Boolean)
                            .join(", ")}
                        </Typography>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div class="qa-oragnization-container">
                          <table className="qa-oragnization-table">
                            <thead>
                              <tr>
                                <th>Technology</th>
                                {/* <th>Track Lead</th> */}
                                <th>QA Champions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {trackAccess &&
                                Object.keys(
                                  trackAccess?.["technology-wise-full-access"]
                                )
                                  .filter((itemm) =>
                                    item.techName.includes(itemm)
                                  )
                                  .map((key, index) => {
                                    return (
                                      <>
                                        <tr>
                                          <td className="td1">{key}</td>
                                          <td className="td3">{`${trackAccess?.[
                                            "technology-wise-full-access"
                                          ][key].join(", ")}`}</td>
                                        </tr>
                                      </>
                                    );
                                  })}
                              {console.log(trackAccess, "trackkacccc")}
                            </tbody>
                          </table>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </>
              );
            })}
          </div>
        </div>
      </div>
      <div className="structure-roles-res accordion__content_active">
        <p>Roles and Responsibilities of QA Champions</p>
        <ul>
          <li>Represent their respective tracks for QA activities</li>
          <li>Familiarize with overall L&TT processes and QA team guidance</li>
          <li>
            Liaise with L&TT QA team for implementation of processes within
            their track
          </li>
          <li>
            Share and update QA artifacts of their respective tracks on regular
            basis
          </li>
          <li>
            Act as primary owner for the discussions with L&TT QA team for
            internal audits
          </li>
          <li>
            QA champion role should be set as one of their priorities as part of
            PA
          </li>
        </ul>
      </div>
      <div className="icons-container">
        <div className="icons-wrap">
          <div className="icons-row row1">
            <div className="icons-box">
              <div className="img-link">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"}
                  alt="Mailicon"
                  className="group-img mailIcon"
                  id="icon-chat"
                />
                <a
                  className="contact-us"
                  target="_blank"
                  href={`mailto: ${mailData.dellearningframework}`}
                >
                  <span className="menu-text">Write to us</span>
                </a>
                {/* <span className="contact-word">Mail</span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="link_container_below">
        <div className="link_cont_wrap">
          <div>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Home/Acc_GT_Dimensional_RGB.png"
              }
              alt="AccentureIcon"
              className="link_accenture_logo"
            />
          </div>
          <div className="link_text_cont">
            <span>
              For any queries or support, you may reach out to
              <a
                className="link_anchor"
                href={`mailto:${mailData.qualityassurance}`}
                target="_blank"
              >
                {" "}
                {mailData.qualityassurance}{" "}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default QAOrganizationContent;
